module.exports = __webpack_public_path__ + "static/media/yash-mission.1156f056.png";